<template>
 <div class="p-4 max-w-main bg-vmain" style="min-height: calc(100vh - 62px);">
    <img @click="$router.push('/')" class="cursor-pointer" src="@/assets/default_main/logo1.svg" />
    <div class="text-center mt-4">
        <div class="font-bold-vmain text-xl mt-3">
            Bổ sung hồ sơ
        </div>
        <ekyc-infor :not_show="true" />

  </div>
 </div>
</template>

<script>
import {getPartner,getMoney,getLogo,getToken} from '@/utils/auth'
import {sendFile} from '@/api/otp'
import ListPartner from './components/listPartner.vue'
import EkycInfor from './components/ekycInfo.vue'
import router from "@/router";

export default {
  components: { ListPartner,EkycInfor },
    data() {
        return {
            
        }
    },
    methods: {
    },
    beforeCreate() {
        if(document.getElementById("no_1")) {
            document.getElementById("no_1").remove();
        }
    },
    head: {
        script: [
            { type: 'text/javascript', src: window.location.origin + router.options.base + '/script/info_ekyc.js'},
            { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=AW-10851243888' ,  async: true,},
        ],
        noscript: [
            {
                inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1361189891010235&ev=PageView&noscript=1"/>'
            }
        ]
    }
}
</script>

<style>
/* ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
    color: transparent;
} */

input[type=date]:required:invalid::-webkit-datetime-edit {
    color: transparent;
}
input[type=date]:focus::-webkit-datetime-edit {
    color: black !important;
}

/* .mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
     color: transparent; 
}

input:focus::-webkit-datetime-edit {
    color: rgba(255, 255, 255, .46) !important; 
} */
</style>